<template>
  <div id="app">
      <router-view style="flex-grow: 1; height: 100%;"/>
  </div>
</template>

<script>
import { L10n, setCulture } from '@syncfusion/ej2-base';

  export default {
    name: 'app',
    components: {
    },
    methods: {
      // Teksty siatek Syncfusion z bieżącego języka. Jeden obiekt pod każdą kulturą z plików
      // językowych (ej2LocaleCulture) — wcześniej Polish.json ustawiał "pl", a teksty były tylko
      // pod "pl-PL", więc np. nagłówki grup zostawały po angielsku.
      setGridCulture() {
        const t = key => this.$root.$i18n.t(key);
        const texts = {
          grid: {
            EmptyRecord: t('emptyRecord'),
            Item: t('item'),
            Items: t('items'),
            Search: t('search'),
            Pdfexport: t('Pdfexport'),
            Excelexport: t('Excelexport'),
            Csvexport: t('Csvexport'),
            FilterButton: t('FilterButton'),
            ClearButton: t('ClearButton'),
            StartsWith: t('StartsWith'),
            EndsWith: t('EndsWith'),
            Contains: t('Contains'),
            Equal: t('Equal'),
            NotEqual: t('NotEqual'),
            LessThan: t('LessThan'),
            LessThanOrEqual: t('LessThanOrEqual'),
            GreaterThan: t('GreaterThan'),
            GreaterThanOrEqual: t('GreaterThanOrEqual'),
            ChooseDate: t('ChooseDate'),
            EnterValue: t('EnterValue'),
            NoResult: t('NoResult'),
            ClearFilter: t('ClearFilter'),
            ChooseColumns: t('ChooseColumns'),
            SelectAll: t('SelectAll'),
            Columnchooser: t('Columnchooser'),
            OKButton: t('OKButton'),
            CancelButton: t('CancelButton')
          },
          pager: {
            pagerDropDown: t('pagerDropDown'),
            currentPageInfo: t('currentPageInfo'),
            totalItemsInfo: t('totalItemsInfo'),
            totalItemInfo: t('totalItemInfo')
          }
        };
        const culture = t('ej2LocaleCulture');
        setCulture(culture);
        L10n.load({ 'en-US': texts, [culture]: texts });
      }
    },
    async mounted() {
      this.$store.dispatch('set_isMobile', /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent))

      this.$root.$i18n.locale = this.$store.getters.language
      this.setGridCulture();
    }
  }
</script>

<style>
@import url('~@/assets/css/bootstrap.css');
@import url('~@/assets/css/style.css');
@import url('~@/assets/css/main-submenu.css');
@import url('~@/assets/css/sidebar-menu.css');
@import url('~@/assets/css/snackbar.css');

@import url('../node_modules/@syncfusion/ej2-base/styles/material.css');
@import url('../node_modules/@syncfusion/ej2-buttons/styles/material.css');
@import url('../node_modules/@syncfusion/ej2-calendars/styles/material.css');
@import url('../node_modules/@syncfusion/ej2-dropdowns/styles/material.css');
@import url('../node_modules/@syncfusion/ej2-inputs/styles/material.css');
@import url('../node_modules/@syncfusion/ej2-navigations/styles/material.css');
@import url('../node_modules/@syncfusion/ej2-popups/styles/material.css');
@import url('../node_modules/@syncfusion/ej2-splitbuttons/styles/material.css');
@import url('../node_modules/@syncfusion/ej2-vue-grids/styles/material.css');

@import url('~@/assets/css/syncfusiongrid.css');
/* Ostatni, żeby nakładka trybu ciemnego nadpisywała style paczek powyżej. */
@import url('~@/assets/css/theme.css');
#app {
  height: 100%;
  display: flex;
  flex-direction: column;
}

</style>



// WEBPACK FOOTER //
// src/App.vue